import { render, staticRenderFns } from "./ReplaceSymbol.vue?vue&type=template&id=476eb1de&scoped=true"
import script from "./ReplaceSymbol.vue?vue&type=script&lang=js"
export * from "./ReplaceSymbol.vue?vue&type=script&lang=js"
import style0 from "./ReplaceSymbol.vue?vue&type=style&index=0&id=476eb1de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476eb1de",
  null
  
)

export default component.exports